<jw-modal id="viewImageModal">
  <div class="row">
    <div class="col">
      @if (this.image.data !== undefined) {
        <img src='data:{{this.image.filetype}};base64,{{this.image.data}}'/>
      }
    </div>
  </div>


  <button class='btn btn-primary' (click)='this.close()'>Close</button>
</jw-modal>
